<template>
  <div class="my-auto text-base flex flex-col gap-5 text-center">
    <div class="flex flex-col items-center gap-2">
      <span class="flex size-12 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
        <triangle-alert-icon class="size-6" />
      </span>
      <h2 class="m-0 text-xl font-semibold text-foreground">
        {{ title }}
      </h2>
      <p v-if="content" class="m-0 text-sm text-foreground/70">
        {{ content }}
      </p>
    </div>

    <ul v-if="items.length !== 0" class="glass-tile m-0 flex max-h-64 list-none flex-col gap-1 overflow-y-auto rounded-xl p-3 text-left text-sm">
      <li v-for="(item, index) in items" :key="'error-dialog-item--' + index" class="truncate">
        {{ item }}
      </li>
    </ul>

    <ui-button class="h-11 w-full" @click="() => close()">
      {{ labelClose ?? tr('OK') }}
    </ui-button>
  </div>
</template>

<script>
import { TriangleAlert } from '@lucide/vue';

/**
 * Content of $errorModal.open(): an error that needs more room than a toast,
 * e.g. the list of items an operation failed on. Plain text only.
 */
export default {
  name: 'ErrorDialog',
  components: {
    TriangleAlertIcon: TriangleAlert,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    // E.g. the names of the failed entities.
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    // Translated 'OK' when not given.
    labelClose: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
  },
  emits: [ 'close' ],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
